/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from 'src/app/model';
import { SearchableProvider } from 'src/app/model/interface';
import { Naics } from 'src/app/model/naics';
import { environment } from 'src/environments/environment';
import { ApiHeaders } from './headers';

@Injectable()
export class RPiProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) { }

  getRPiList(page: number, query: string): Observable<RestResponse> {
    return this.http.
      get<RestResponse>(`${environment.API_URL}/api/bvq/rpi/list?page=${page}` +
        (query ? '&query=' + encodeURIComponent(query) : ''),
      ApiHeaders.getOptions());
  }

  getById(id: number): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(environment.API_URL + '/api/bvq/rpi/' + id, ApiHeaders.getOptions());
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  saveNaics(naics: Naics): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(environment.API_URL + '/api/bvq/naics', naics, ApiHeaders.getOptions());
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getRPiList(page ? page : 1, query);
  }

  getSearchType(): string {
    return 'RPI';
  }
}
